import DefaultSkeleton from '@mindtickle/skeleton/DefaultSkeleton';

const menuActionLoaderPropData = {
  title: { width: '180px', style: { height: '32px', margin: '0 0 0 16px' } },
  paragraph: false,
  active: true,
  avatar: false,
};

export const MenuActionLoader = () => <DefaultSkeleton {...menuActionLoaderPropData} />;
